import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type TMasterState = {
    data: [],
    perPage: number,
    currentPage: number,
    totalPage: number,
    searchTerm: string,
    loading: boolean,
    sortBy: string,
    sortColumn: string,
    rerender1: boolean,
    totalCount: number
}

const initialMasterState: TMasterState = {
    data: [],
    perPage: 10,
    currentPage: 1,
    totalPage: 1,
    searchTerm: "",
    loading: false,
    sortBy: "desc",
    sortColumn: "",
    rerender1: false,
    totalCount: 0
}

export const masterSlice = createSlice({
    name: 'master',
    initialState: initialMasterState,
    reducers: {
        setMaster: (state: TMasterState, { payload }: PayloadAction<[]>) => {
            state.data = payload
        },
        setPerPage: (state: TMasterState, { payload }: PayloadAction<number>) => {
            state.perPage = payload;
        },
        setTotalCount: (state: TMasterState, { payload }: PayloadAction<number>) => {
            state.totalCount = payload;
        },
        setCurrentPage: (state: TMasterState, { payload }: PayloadAction<number>) => {
            state.currentPage = payload;
        },
        setTotalPage: (state: TMasterState, { payload }: PayloadAction<number>) => {
            state.totalPage = payload;
        },
        setSearchTerm: (state: TMasterState, { payload }: PayloadAction<string>) => {
            state.searchTerm = payload;
        },
        setLoading: (state: TMasterState, { payload }: PayloadAction<boolean>) => {
            state.loading = payload;
        },
        setSortBy: (state: TMasterState, { payload }: PayloadAction<string>) => {
            state.sortBy = payload;
        },
        setSortColumn: (state: TMasterState, { payload }: PayloadAction<string>) => {
            state.sortColumn = payload;
        },
        setRerender: (state: TMasterState, { payload }: PayloadAction<boolean>) => {
            state.rerender1 = payload;
        }
    }
})

export const {
    setMaster,
    setPerPage,
    setCurrentPage,
    setTotalPage,
    setSearchTerm,
    setLoading,
    setSortBy,
    setSortColumn,
    setRerender,
    setTotalCount
} = masterSlice.actions

export default masterSlice.reducer
